import {useEffect, useRef} from "react";

import {isServer} from "@/shared/utils/runtime";

interface Props {
    locked: boolean;
}

export function useLockedBody({locked}: Props): void {
    const scrollYRef = useRef(0);
    const wasLockedRef = useRef(false);

    useEffect(() => {
        if (isServer()) return;

        const body = document.body;

        if (locked) {
            wasLockedRef.current = true;
            // Save current scroll position before locking
            scrollYRef.current = window.scrollY;
            body.style.top = `-${scrollYRef.current}px`;
            body.classList.add("body_locked_mobile");
        } else {
            body.classList.remove("body_locked_mobile");
            body.style.top = "";
            // Restore scroll only when unlocking (not on initial mount when locked is false)
            if (wasLockedRef.current) {
                wasLockedRef.current = false;
                window.scrollTo({top: scrollYRef.current, behavior: "instant"});
            }
        }

        return () => {
            body.classList.remove("body_locked_mobile");
            body.style.top = "";
            if (wasLockedRef.current) {
                window.scrollTo({top: scrollYRef.current, behavior: "instant"});
            }
        };
    }, [locked]);
}
